
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/persons",
      function () {
        return require("private-next-pages/persons/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/persons"])
      });
    }
  